import React from 'react';
import { Check } from 'lucide-react';
import './Benefits.css';

const Benefits = () => {
  const benefits = [
    'Prevent reputational risk before publication',
    'Enforce communication governance across teams',
    'Safely scale AI-assisted communication',
    'Maintain executive oversight',
  ];

  return (
    <section className="benefits section" data-testid="benefits-section">
      <div className="container">
        <div className="benefits-content">
          <div className="benefits-text">
            <h2 className="benefits-title" data-testid="benefits-title">
              Enterprise Benefits
            </h2>
            <p className="benefits-subtitle">
              Transform AI communication risk into strategic advantage
            </p>
          </div>
          
          <div className="benefits-list" data-testid="benefits-list">
            {benefits.map((benefit, index) => (
              <div key={index} className="benefit-item" data-testid={`benefit-item-${index}`}>
                <div className="benefit-check">
                  <Check size={18} />
                </div>
                <span className="benefit-text">{benefit}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Benefits;
